import React, { useState, useEffect } from 'react';
import LoginPage from './pages/LoginPage';
import Dashboard from './pages/Dashboard';
import Watchlist from './pages/Watchlist';
import AccountDetail from './pages/AccountDetail';
import CampaignPush from './pages/CampaignPush';
import Creatives from './pages/Creatives';
import AdAgent from './pages/AdAgent';
import Analyse from './pages/Analyse';
import Settings from './pages/Settings';
import { PageKey } from './components/Layout';
import './index.css';

type Route =
  | { page: 'dashboard' }
  | { page: 'watchlist' }
  | { page: 'account'; accountId: string; accountName: string }
  | { page: 'push' }
  | { page: 'creatives' }
  | { page: 'adagent' }
  | { page: 'analyse' }
  | { page: 'settings' };

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState<{ email: string; name: string } | null>(null);
  const [route, setRoute] = useState<Route>({ page: 'dashboard' });

  useEffect(() => {
    const token = localStorage.getItem('ps_token');
    const savedUser = localStorage.getItem('ps_user');
    if (token && savedUser) { setIsLoggedIn(true); setUser(JSON.parse(savedUser)); }
    // Deep-Link: ?account=act_123&name=... (z.B. aus „in neuem Tab öffnen")
    const params = new URLSearchParams(window.location.search);
    const acc = params.get('account');
    if (acc) setRoute({ page: 'account', accountId: acc, accountName: params.get('name') || acc });
  }, []);

  const handleLogin = (userData: { email: string; name: string }, token: string) => {
    localStorage.setItem('ps_token', token);
    localStorage.setItem('ps_user', JSON.stringify(userData));
    setUser(userData);
    setIsLoggedIn(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('ps_token');
    localStorage.removeItem('ps_user');
    setUser(null); setIsLoggedIn(false); setRoute({ page: 'dashboard' });
  };

  const navigate = (page: PageKey) => setRoute({ page } as Route);

  if (!isLoggedIn) return <LoginPage onLogin={handleLogin} />;

  if (route.page === 'account') {
    return <AccountDetail accountId={route.accountId} accountName={route.accountName} user={user!} onLogout={handleLogout} onBack={() => setRoute({ page: 'dashboard' })} onNavigate={navigate} />;
  }
  if (route.page === 'watchlist') {
    return <Watchlist user={user!} onLogout={handleLogout} onNavigate={navigate}
      onOpenAccount={(id, name) => setRoute({ page: 'account', accountId: id, accountName: name })} />;
  }
  if (route.page === 'push') {
    return <CampaignPush user={user!} onLogout={handleLogout} onNavigate={navigate} />;
  }
  if (route.page === 'creatives') {
    return <Creatives user={user!} onLogout={handleLogout} onNavigate={navigate} />;
  }
  if (route.page === 'adagent') {
    return <AdAgent user={user!} onLogout={handleLogout} onNavigate={navigate} />;
  }
  if (route.page === 'analyse') {
    return <Analyse user={user!} onLogout={handleLogout} onNavigate={navigate}
      onOpenAccount={(id, name) => setRoute({ page: 'account', accountId: id, accountName: name })} />;
  }
  if (route.page === 'settings') {
    return <Settings user={user!} onLogout={handleLogout} onNavigate={navigate} />;
  }

  return (
    <Dashboard
      user={user!} onLogout={handleLogout} onNavigate={navigate}
      onOpenAccount={(id, name) => setRoute({ page: 'account', accountId: id, accountName: name })}
    />
  );
}

export default App;
